const homeIds = {
  carousel: `carousel`,
  carouselSection: `carouselSection`,
  carouselImage: `carouselImage{{key}}`,

  shopByCat: `shopByCat`,
  shopByCatHeader: `shopByCatHeader`,
  shopByCatBody: `shopByCatBody`,
  catGrid: `catGrid{{key}}`,
  cat: `cat{{key}}`,
  subCatGrid: `subCatGrid{{key}}`,
  subCat: `subCat{{key}}`,
  subCatSeeAll: `subCatSeeAll{{key}}`,

  popParts: `popParts`,
  popPartHeader: `popPartHeader`,
  popPartsGrid: `popPartGrid`,
  popPart: `popPart{{key}}`,
  seeAllPopParts: `seeAllPopParts`,
  seeAllPopPartsBtn: `seeAllPopPartsBtn`,

  popBrands: `popBrands`,
  popBrandHeader: `popBrandHeader`,
  popBrandsGrid: `popBrandsGrid`,
  popBrand: `popBrand{{key}}`,
  seeAllPopBrands: `seeAllPopBrands`,
  seeAllPopBrandsBtn: `seeAllPopBrandsBtn`,

  deals: `deals`,
  dealsGrid: `dealsGrid`,
  deal: `deal{{key}}`,

  blogs: `blogs`,
  inTheGarageBlog: `inTheGarageBlog`,
  blogGrid: `blogGrid`,
  blog: `blog{{key}}`,

  whyChoose: `whyChoose`,
  whyChooseHeader: `whyChooseHeader`,
  whyChooseSection: `whyChooseSection{{key}}`,

  customersSaying: `customersSaying`,
  customersSayingHeader: `customersSayingHeader`,
  customerSaying: "customerSaying{{key}}",

  popMakes: `popMakes`,
  popMakeHeader: `popMakeHeader`,
  popMakesGrid: `popMakesGrid`,
  popMake: `popMake{{key}}`,
  seeAllPopMakes: `seeAllPopMakes`,
  seeAllPopMakesBtn: `seeAllPopMakesBtn`,

  ratings: `ratings`,
  ratingSection: `ratingSection`,
  ratingsGrid: `ratingsGrid`
};

export default homeIds;
